import { useState } from 'react';
import { OptimizedImage } from '@/components/ui/OptimizedImage';

interface PropertyGalleryProps {
  images: string[];
  title: string;
  className?: string;
}

export function PropertyGallery({ images, title, className }: PropertyGalleryProps) {
  const [selectedImage, setSelectedImage] = useState(0);

  if (images.length === 0) return null;

  return (
    <div className={className}>
      {/* Main Image */}
      <div className="relative h-96 rounded-xl overflow-hidden mb-4">
        <OptimizedImage
          src={images[selectedImage]}
          alt={`${title} - Imagen ${selectedImage + 1}`}
          className="w-full h-full"
          objectFit="cover"
          priority={selectedImage === 0}
        />
        <div className="absolute top-4 right-4 bg-black/70 text-white px-3 py-1 rounded-full text-sm">
          {selectedImage + 1} / {images.length}
        </div>
      </div>

      {/* Thumbnail Grid */}
      {images.length > 1 && (
        <div className="grid grid-cols-4 md:grid-cols-6 gap-2">
          {images.map((image, index) => (
            <button
              key={index}
              onClick={() => setSelectedImage(index)}
              className={`relative h-20 rounded-lg overflow-hidden border-2 transition-all ${
                selectedImage === index 
                  ? "border-blue-500 ring-2 ring-blue-200" 
                  : "border-gray-200 hover:border-gray-300"
              }`}
            >
              <OptimizedImage
                src={image}
                alt={`${title} - Miniatura ${index + 1}`}
                className="w-full h-full"
                objectFit="cover"
                priority={false}
              />
            </button>
          ))}
        </div>
      )}
    </div>
  );
}